<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
        </p>
        <span class="md:flex hidden items-center">
          <!--<span>&copy;&nbsp;</span>
          <span>{{ new Date().getFullYear() }} </span>-->
          <a href="https://www.xyloimpact.com" target="_blank" rel="nofollow">&nbsp;XYLO SOFTWARE</a>&nbsp;<small>VERSION 1.0.7 (24/11/2022)</small>
          <span class="hidden sm:inline-block"></span>
        </span>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
